module.exports = __webpack_public_path__ + "img/a_e1.f9c4090f.png";